const pageNameKey = "ticketPageChatHeader";

export const ticketPageChatHeaderEn = {
  [pageNameKey]: {
    supportDetails: "Support Details",
  },
};

export const ticketPageChatHeaderPtBr = {
  [pageNameKey]: {
    supportDetails: "Detalhes do suporte",
  },
};

export const ticketPageChatHeaderDe = {
  [pageNameKey]: {
    supportDetails: "Support-Details",
  },
};

export const ticketPageChatHeaderZhHans = {
  [pageNameKey]: {
    supportDetails: "支持详情",
  },
};

export const ticketPageChatHeaderIt = {
  [pageNameKey]: {
    supportDetails: "Dettagli di supporto",
  },
};

export const ticketPageChatHeaderEs = {
  [pageNameKey]: {
    supportDetails: "Detalles de soporte",
  },
};

export const ticketPageChatHeaderNl = {
  [pageNameKey]: {
    supportDetails: "Supportdetails",
  },
};

export const ticketPageChatHeaderTr = {
  [pageNameKey]: {
    supportDetails: "Destek Ayrıntıları",
  },
};
